import styled from 'styled-components';

const VideoStyle = styled.div`
	&.videoWrap {
		position: relative;

		video {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
`;

export default VideoStyle;
